import CertificateIcon from "@/components/icons/CertificateIcon";
import PaperCourseCertificate from "@/components/courses/PaperCourseCertificate";

import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
dayjs.extend(advancedFormat);

export default {
    components: {
        CertificateIcon,
        PaperCourseCertificate
    },
    computed: {
        statusText() {
            switch (this.paperCourse.completion_status) {
                case "completed":
                    return "Completed";
                case "passed":
                    return "Passed";
                case "failed":
                    return "More Training Needed";
                default:
                    return "N/A";
            }
        },
        statusIconComponentName() {
            switch (this.paperCourse.completion_status) {
                case "completed":
                    return "IconPassed";
                case "passed":
                    return "IconPassed";
                case "failed":
                    return "IconFailed";
                default:
                    return "IconNotStarted";
            }
        },
        score() {
            switch (this.paperCourse.completion_status) {
                case "passed":
                case "failed":
                    return this.paperCourse.score;
                default:
                    return null;
            }
        },
        certificateAllowed() {
            switch (this.paperCourse.completion_status) {
                case "completed":
                case "passed":
                    if (this.paperCourse.group_id) {
                        return this.paperCourse.members_can_access_certificates != 0;
                    } else {
                        //solo (never happens with paper courses though)
                        return true;
                    }
                default:
                    return false;
            }
        },
        dateFinished() {
            return dayjs(this.paperCourse.completed_at).format("D-MM-YY");
        }
    }
};
